import { FC } from "react";
import { useTranslation } from "react-i18next";
import SaleTabPane, { TabProps } from "../../../../components/TabPane";
import SDoc from "@/components/SDoc";
import { SaleOrderItemState } from "@/types/sales";
import OrderList from "./components/OrderList";

type CustomerTabType = 'doc'

const SalesOrder: FC = () => {
  const { t } = useTranslation();
  const TAB_LIST_KEY = "customer-list"
  const TAB_DOC_KEY = "customer-doc"

  const keyObj: (info: SaleOrderItemState) => { [key in CustomerTabType]: TabProps } = (info) => ({
    doc: {
      key: TAB_DOC_KEY,
      label: (info.number) + ' ' + t('sale.documents'),
      children: <SDoc docId={info.docId} />
    },
  })

  return <SaleTabPane<SaleOrderItemState> defaultKey={TAB_LIST_KEY} defaultTabs={[
    {
      key: TAB_LIST_KEY,
      label: t("sale.orderList"),
      children: <OrderList />,
      closable: false,
    },
  ]} onOpens={(info) => keyObj(info)} style={{ marginBottom: 6 }} />
}

export default SalesOrder;